import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { verifyEmailToken } from '../../services/emailVerificationService';
import '../Login/Login.css';
import './VerifyEmailPage.css';

const PAGE_STATES = {
  loading: {
    title: 'Verifying your email...',
    lines: ['Please wait.'],
  },
  missing: {
    title: 'Verification link is invalid',
    lines: ['The verification token is missing.'],
  },
  success: {
    icon: '✅',
    title: 'Email verified successfully',
    lines: [
      'Your account has been successfully verified.',
      'You can now sign in.',
    ],
  },
  invalid: {
    icon: '❌',
    title: 'Verification failed',
    lines: ['Invalid or expired verification link.'],
  },
  error: {
    title: 'Verification failed',
    lines: ['Unable to contact the server.', 'Please try again later.'],
  },
};

const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token')?.trim() || '';
  const [pageState, setPageState] = useState(token ? 'loading' : 'missing');

  useEffect(() => {
    if (!token) {
      setPageState('missing');
      return undefined;
    }

    let isActive = true;
    setPageState('loading');

    verifyEmailToken(token)
      .then(() => {
        if (isActive) {
          setPageState('success');
        }
      })
      .catch((error) => {
        if (!isActive) {
          return;
        }

        setPageState(error?.response?.status === 400 ? 'invalid' : 'error');
      });

    return () => {
      isActive = false;
    };
  }, [token]);

  const content = PAGE_STATES[pageState];
  const isLoading = pageState === 'loading';

  return (
    <main className="loginPage">
      <section
        className="loginCard verifyEmailCard"
        aria-labelledby="verify-email-title"
        aria-busy={isLoading}
      >
        {isLoading && (
          <div
            className="spinner-border verifyEmailSpinner"
            role="status"
            aria-label="Verifying email"
          />
        )}

        {content.icon && (
          <div className="verifyEmailIcon" aria-hidden="true">
            {content.icon}
          </div>
        )}

        <h1 id="verify-email-title">{content.title}</h1>

        <div className="verifyEmailText">
          {content.lines.map((line) => (
            <p key={line}>{line}</p>
          ))}
        </div>

        {!isLoading && (
          <button
            className="loginSubmitButton verifyEmailButton"
            type="button"
            onClick={() => navigate('/login')}
          >
            Go to Sign In
          </button>
        )}
      </section>
    </main>
  );
};

export default VerifyEmailPage;
